module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('midea-lottie-view', {
    style: (_vm._px2rem(_vm.styleConfig_, 75)),
    attrs: {
      "data": _vm.lottieData,
      "loop": true
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee29cad8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee29cad8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-spinner/index.vue
// module id = 676
// module chunks = 0 1